module.exports = __webpack_public_path__ + "img/world.c3d92af7.png";